import _ from "lodash";
import React, { useEffect, useState } from "react";
import classes from "./DurationAndTopic.scss";
import TimeSelector from "UIComponents/TimeSelector";

const DurationAndTopic = props => {
  const [duration, setDuration] = useState("");

  const { updateInputField } = props;

  useEffect(() => {
    const assessmentFields = _.get(props, "assessmentFields", {});
    if (assessmentFields) {
      const oldDuration = _.get(
        _.find(assessmentFields, field =>
          _.isEqual(_.get(field, "uid"), "duration")
        ),
        "value"
      );

      if (!_.isNull(oldDuration) && oldDuration !== 0) {
        setDuration(oldDuration);
      }
    }
  }, []);

  const onChangeDuration = ({ duration = 0 }) => {
    setDuration(duration);
    updateInputField({ duration });
  };

  return (
    <div className={classes.container}>
      <div className={classes.termsDropdown}>
        <TimeSelector
          {...props}
          storeValueInSeconds={true}
          SelectedTimeformat="H [h] mm [m]"
          name={"duration"}
          value={duration ? duration : 0}
          updateInputField={onChangeDuration}
          placeholder={"common:select_with_label"}
          timeComponentStyle={{ height: "46px" }}
          borderStyle={{ borderRadius: "6px" }}
        />
      </div>
    </div>
  );
};

export default DurationAndTopic;
